import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { setAuthToken, setUser } from '../utils/auth';
import { ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password
      });

      setAuthToken(response.data.access_token);
      setUser(response.data.user);
      toast.success('Login berhasil!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Email atau password salah');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 relative">
        <img
          src="/images/banner.webp"
          alt="Construction site safety"
          className="w-full h-full object-cover object-[30%_center]"
          loading="lazy"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-[#0c3c30]/90 via-[#0c3c30]/40 to-transparent flex items-end">
          <div className="p-12">
            <h2 className="text-2xl font-bold text-white mb-4">
              Digital Work Permit - PT. Flora Food Manufacturing Indonesia
            </h2>
            <p className="text-white/90 text-lg">
              @2026 v.2.0
            </p>
          </div>
        </div>
      </div>



      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 rounded-lg flex items-center justify-center">
              <img
                src="/images/logo1.png"
                alt="PT. Flora Food Manufacturing Indonesia"
                className="w-15 h-15 object-contain"
                draggable="false"
              />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-[#0c3c30]">
                Digital Work Permit
              </h1>
              <p className="text-slate-600 text-sm">
                PT. FLORA FOOD MANUFACTURING INDONESIA
              </p>
            </div>
          </div>


          <div className="bg-white p-8 rounded-lg shadow-sm border border-slate-200">
            <h2 className="text-2xl font-semibold text-[#0c3c30] mb-6">Masuk ke Sistem</h2>
            
            <form onSubmit={handleLogin} className="space-y-5">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  data-testid="email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#0c3c30] focus:border-transparent transition-all"
                  placeholder="email.kamu@perusahaan.com"
                />
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-2">
                  Kata Sandi
                </label>
                <input
                  id="password"
                  type="password"
                  data-testid="password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#0c3c30] focus:border-transparent transition-all"
                  placeholder="••••••••"
                />
              </div>

              <button
                type="submit"
                data-testid="login-button"
                disabled={loading}
                className="w-full bg-[#0c3c30] text-white font-medium py-3 px-6 rounded-md hover:bg-[#082820] transition-all shadow-sm active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Harap tunggu...' : 'Masuk'}
              </button>
            </form>

            <div className="mt-6 pt-6 border-t border-slate-200">
              <p className="text-sm text-slate-500 text-center">
                Tidak Punya Akun?<br />
                <span className="font-mono text-xs">Daftar Melalui PIC Project</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
